import React, { Component } from 'react'
import TileLayer from '../../TileLayer/TileLayer'
import styles from './UpdatingLayer.scss'
import { diff } from '../../../utils'

export type IProps = {
  url: string,
  className: any,
  contour: any,
  hasDifferentLayers: Boolean
}
export type IState = {
  layers: Array<IProps>
}

class UpdatingLayer extends Component<IProps, IState> {

  nextLayer = null

  constructor(props: IProps) {
    super(props)
    this.state = {
      layers: [],
    }
  }

  componentDidMount() {
    this.setState({ layers: [this.props], layer: this.props })
  }


  shouldComponentUpdate(nextProps: IProps, nextState: IState) {
    if (nextProps.url !== this.props.url) {
      const newLayers = this.state.layers.slice(0)
      newLayers.push(nextProps)
      this.setState({ layers: newLayers, layer: nextProps })
      return true
    }
    return true
  }

  render() {
    if (this.state.layers.length === 0) {
      return null
    }

    if (this.props.hasDifferentLayers) {
      const layer = this.state.layer
      const index = 0

      return (
        <TileLayer
          {...layer}
          key={`Layer_${index}`}
          className={`PreviewLayer PreviewLayer_${index} ${layer.className ? layer.className : ''}`}
          contour={this.props.contour}
          isSelected={true}
          ref={(ref) => {
            if (index === this.state.layers.length - 1 && ref) {
              ref.leafletElement.on('load', () => {
                const domLayer = document.querySelector(`.PreviewLayer_${index - 1}`)
                if (domLayer) {
                  setTimeout(() => {
                    domLayer.style.opacity = '0'
                  }, 150)
                }
              })
            }
          }}
        />
      )
    } else {
      return this.state.layers.map((layer, index) => {
        if (index === this.state.layers.length - 1 || index === this.state.layers.length - 2) {
          return (
            <TileLayer
              {...layer}
              key={`Layer_${index}`}
              className={`PreviewLayer PreviewLayer_${index} ${layer.className ? layer.className : ''}`}
              contour={this.props.contour}
              isSelected={true}
              ref={(ref) => {
                if (index === this.state.layers.length - 1 && ref) {
                  ref.leafletElement.on('load', () => {
                    const domLayer = document.querySelector(`.PreviewLayer_${index - 1}`)
                    console.log('domLayer', domLayer)
                    if (domLayer) {
                      setTimeout(() => {
                        domLayer.style.opacity = '0'
                      }, 150)
                    }
                  })
                }
              }}
            />
          )
        } else {
          return null
        }
      })
    }
  }
}

export default UpdatingLayer